<template>
  <div class="spinner-container">
    <div class="spinner">
      <div class="cube1" style="background-color: #f7931e"></div>
      <div class="cube2" style="background-color: #f7931e"></div>
    </div>
  </div>
</template>

<style scoped>
.spinner-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 99999;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-line-pack: center;
  align-content: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.spinner {
  margin: 0 auto;
  width: 50px;
  height: 200px;
}

.cube1,
.cube2 {
  background-color: #fff;
  width: 15px;
  height: 15px;
  -webkit-animation: sk-cubemove 1.5s infinite ease-in-out;
  animation: sk-cubemove 1.5s infinite ease-in-out;
}

.cube2 {
  -webkit-animation-delay: -0.75s;
  animation-delay: -0.75s;
}

@keyframes sk-cubemove {
  25% {
    transform: translateX(40px) rotate(-90deg) scale(0.5);
    -webkit-transform: translateX(40px) rotate(-90deg) scale(0.5);
  }
  50% {
    transform: translateX(40px) translateY(40px) rotate(-179deg);
    -webkit-transform: translateX(40px) translateY(40px) rotate(-179deg);
  }
  50.00001% {
    transform: translateX(40px) translateY(40px) rotate(-180deg);
    -webkit-transform: translateX(40px) translateY(40px) rotate(-180deg);
  }
  75% {
    transform: translateX(0px) translateY(40px) rotate(-270deg) scale(0.5);
    -webkit-transform: translateX(0px) translateY(40px) rotate(-270deg)
      scale(0.5);
  }
  100% {
    transform: rotate(-360deg);
    -webkit-transform: rotate(-360deg);
  }
}
</style>

<script>
export default {
  name: 'loading-animation',
};
</script>
